const APP_CONST = {
    SUCCESS : "SUCCESS",
    FAILURE : "FAILURE",
    CHECKED: "CHECKED",
    OPEN: "OPEN",
    STEP:{
        ONE:'One',
        TWO:'Two',
        THREE:'Three',
        FOUR:'Four',
    },
    QUERY:{
        PRODUCT_ID: "productId"
    },
    ORDER_STATUS:{
        1:"Ordered",
        2:"Packed",
        3:"Shipped",
        4:"Out For Delivery",
        5:"Delivered"
    },
    DATE_FORMAT:{
        MDtY : 'Month_Date_Year',
        DyDtM : 'Day_Date_Month'
    }
};

export default APP_CONST;